import React, { useContext, useEffect, useRef } from 'react'
import Close_btn from './Assets/Menu.svg';
import "./offcanvas.css";
import mainContext from '../../contexts/mainContext';
import Notifications from './Notifications/Notifications'

const OffCanvas = () => {

    const firstUpdate = useRef(true);
    const context = useContext(mainContext);

    const {
        inCanvas,
        setinCanvas,
        canvasTitle,
        canvasSubTitle,
    } = context;

    const handleCanvasClose = () => {
        document.querySelector(".off_canvas_main_div").classList.remove("off_canvas_active");
        setinCanvas("unset");
    }

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        if (inCanvas === "unset") {
            handleCanvasClose();
            return;
        }
        else {
            document.querySelector(".off_canvas_main_div").classList.add("off_canvas_active");
        }
        //eslint-disable-next-line
    }, [inCanvas]);
    return (
        <>
            <div className="off_canvas_main_div">
                <span className="before" onClick={handleCanvasClose}></span>
                <div className="off_canvas_header">
                    <div className="off_canvs_title">
                        <h3>{canvasTitle}</h3>
                        <small>{canvasSubTitle}</small>
                    </div>
                    <span onClick={handleCanvasClose}><img src={Close_btn} alt='' /></span>
                </div>
                <div className="off_canvas_content">
                    {
                        inCanvas === "Notification" &&
                        <Notifications />
                    }

                </div>
            </div>
        </>
    )
}

export default OffCanvas